import { NoticesData } from '../components/notice/noticeTypes';
import localNoticesData from '../components/notice/noticesData.json';

const GOOGLE_DRIVE_API_KEY = 'AIzaSyCoOBoxdyl5-4sHLdNr_Z8a0SrEsSqqu_s';

export async function fetchNoticesData(
  driveFileId: string
): Promise<NoticesData> {
  try {
    if (!GOOGLE_DRIVE_API_KEY) {
      console.info('🔑 No API key found, using local data');
      return localNoticesData as NoticesData;
    }

    // Create AbortController for timeout
    const controller = new AbortController();
    const timeoutId = setTimeout(() => controller.abort(), 3000); // 3 second timeout

    // Using Google Drive API v3 with API key
    const response = await fetch(
      `https://www.googleapis.com/drive/v3/files/${driveFileId}?alt=media&key=${GOOGLE_DRIVE_API_KEY}`,
      {
        method: 'GET',
        headers: {
          Accept: 'application/json',
        },
        signal: controller.signal,
      }
    );

    clearTimeout(timeoutId); // Clear timeout if request completes

    if (!response.ok) {
      console.error('🚨 Google Drive API Error:', {
        status: response.status,
        statusText: response.statusText,
        url: response.url,
      });
      return localNoticesData as NoticesData;
    }

    const data = await response.json();
    return data as NoticesData;
  } catch (error) {
    console.error('🔥 Failed to fetch notices data:', {
      error,
      fallback: 'Using local data',
    });
    return localNoticesData as NoticesData;
  }
}
